import styled from '@emotion/styled';
import { Component } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

import {
  StandardLogoText,
  SystemProtectionLogo,
  PreferredProtectionLogo,
  PlatinumProtectionLogo,
  StandardWarrantyTitle,
  FlexWrapper,
  WarrantyType,
  SpecificWarranty,
  WarrantyDetailsTable,
  WarrantyDetailsCol,
  WarrantyDetailsHeader,
  WarrantyDetail,
  WarrantyDetailName,
  WarrantyDetailValue,
  FlexRow,
  FlexCol,
  WarrantyTableHeader,
  EmptyGridCorner,
  CoverageWarrantyWrapper,
  CoverageWrapper,
  WarrantiesWrapper,
  CoverageHeader,
  CategoryHeader,
} from './components.js';
import { dataTrackMap, ASSET_URLS } from '../../utils';
import { WARRANTIES, POPOVERS } from '../data.js';

const Modal = styled.div`
  display: ${props => (props.show ? 'block' : 'none')};
  position: fixed;
  z-index: 55;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
`;

const ModalContent = styled.div`
  position: relative;
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  border: 1px solid #888;
  width: 75%;
  height: 200px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  -webkit-animation-name: animatetop;
  -webkit-animation-duration: 0.4s;
  animation-name: animatetop;
  animation-duration: 0.4s;
  border-radius: 2px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #cacaca;
`;

const ModalHeader = styled.div`
  padding: 2px 16px;
  background-color: #efefef;
  color: black;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-family: akzidenz-grotesk;
  font-size: 16px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  border-bottom: 1px solid #cbcbcb;
`;

const ModalBody = styled.div`
  padding: 2px 16px;
`;

const ModalCloseButton = styled.div`
  color: #aaaaaa;
  float: right;
  font-weight: bold;
  font-size: 30px;
  position: absolute;
  right: -7px;
  top: -8px;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  border: solid 1px #cacaca;
  background-color: #ffffff;
  &:hover,
  &:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }
`;

const MoreInfo = styled.i`
  margin-left: 7px;
  color: #65656a;
  display: inline-block;
  cursor: pointer;
  padding: 5px;
`;

class SingleWarrantyLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      colors: {
        pink: '#fde4f0',
        gray: '#dadada',
        lightGray: '#e8e8e8',
        hoverGray: 'rgba(119, 119, 119, .35)',
        hoverPink: 'rgba(249,159,201,.35)',
        lightPink: '#fef1f7',
      },
      showModal: false,
      modalTitle: '',
      modalBody: '',
    };
  }

  isExtended() {
    return this.props.extended;
  }

  getWarranty() {
    return WARRANTIES.find((warranty, index) => warranty.slug === this.props.activeWarranty);
  }

  infoPopover(id, titleText, bodyText) {
    const { InfoCircle } = ASSET_URLS;
    return (
      <OverlayTrigger
        trigger="click"
        placement="right"
        rootClose
        overlay={
          <Popover id={id} style={{ opacity: 1 }} placement="right">
            <Popover.Title>{titleText}</Popover.Title>
            <Popover.Content>{bodyText}</Popover.Content>
          </Popover>
        }
      >
        <img
          src={InfoCircle}
          style={{
            display: 'inline',
            marginLeft: '7px',
          }}
          {...dataTrackMap({
            track: 'tooltip',
            destination: `${titleText} Tooltip`,
          })}
        />
      </OverlayTrigger>
    );
  }

  renderLeftColumn() {
    const warranty = this.getWarranty();
    const { pink, gray, lightPink, hoverPink, hoverGray, lightGray } = this.state.colors;
    const { I_CIRCLE } = ASSET_URLS;
    const productDefectsCoverage = warranty['Product Defects Coverage'].map((attrib, index) => {
      const key = Object.keys(attrib);
      const value = attrib[key];
      const popoverData = POPOVERS.find(o => o.name === key.toString());
      let popoverTitle;
      let popoverBody;
      if (popoverData) {
        popoverTitle = popoverData.titleText;
        popoverBody = popoverData.bodyText;
      }
      return (
        <WarrantyDetail key={index} flexGrowValue={1}>
          <WarrantyDetailName style={{ paddingTop: '11px', paddingBottom: '11px' }}>
            <div
              style={{
                width: '100%',
                textAlign: 'right',
                fontFamily: 'OCRoboto',
                display: 'inline',
              }}
              dangerouslySetInnerHTML={{
                __html: key,
              }}
            />
            {popoverTitle ? this.infoPopover(index, popoverTitle, popoverBody) : ''}
          </WarrantyDetailName>
          <WarrantyDetailValue
            bgColor={this.isExtended() ? lightPink : lightGray}
            style={{ paddingTop: '11px', paddingBottom: '11px' }}
          >
            <div
              style={{ width: '100%' }}
              dangerouslySetInnerHTML={{
                __html: value,
              }}
            />
          </WarrantyDetailValue>
        </WarrantyDetail>
      );
    });
    return (
      <WarrantyDetailsCol>
        <WarrantyDetailsHeader>{Object.keys(warranty)[2]}</WarrantyDetailsHeader>
        {productDefectsCoverage}
      </WarrantyDetailsCol>
    );
  }

  renderRightColumn() {
    const warranty = this.getWarranty();
    const { pink, gray, lightPink, hoverPink, hoverGray, lightGray } = this.state.colors;
    const { I_CIRCLE } = ASSET_URLS;
    const workmanshipCoverage = warranty['Workmanship Coverage'].map((attrib, index) => {
      const key = Object.keys(attrib);
      const value = attrib[key];
      return (
        <WarrantyDetail key={index} flexGrowValue={1}>
          <WarrantyDetailName>
            <div
              style={{ width: '100%', textAlign: 'right', display: 'inline', fontFamily: 'OCRoboto' }}
              dangerouslySetInnerHTML={{
                __html: key,
              }}
            />
            <img
              src={I_CIRCLE}
              style={{
                display: 'inline',
                marginLeft: '7px',
              }}
            />
          </WarrantyDetailName>
          <WarrantyDetailValue bgColor={this.isExtended() ? lightPink : lightGray}>
            <div
              style={{ width: '100%' }}
              dangerouslySetInnerHTML={{
                __html: value,
              }}
            />
          </WarrantyDetailValue>
        </WarrantyDetail>
      );
    });

    const keyRequirements = warranty['Key Requirements'].map((attrib, index) => {
      const key = Object.keys(attrib);
      const value = attrib[key];
      return (
        <WarrantyDetail key={index} flexGrowValue={key[0] === 'Contractor Certification Required' ? '50' : '1'}>
          <WarrantyDetailName>
            <div
              style={{ textAlign: 'left', display: 'inline', fontFamily: 'OCRoboto' }}
              dangerouslySetInnerHTML={{
                __html: key,
              }}
            />
            <img
              src={I_CIRCLE}
              style={{
                display: 'inline',
                marginLeft: '7px',
              }}
            />
          </WarrantyDetailName>
          <WarrantyDetailValue bgColor={this.isExtended() ? lightPink : lightGray}>
            <div
              style={{ width: '100%' }}
              dangerouslySetInnerHTML={{
                __html: value,
              }}
            />
          </WarrantyDetailValue>
        </WarrantyDetail>
      );
    });

    return (
      <WarrantyDetailsCol>
        <WarrantyDetailsHeader>{Object.keys(warranty)[3]}</WarrantyDetailsHeader>
        {workmanshipCoverage}
        <WarrantyDetailsHeader>{Object.keys(warranty)[4]}</WarrantyDetailsHeader>
        {keyRequirements}
      </WarrantyDetailsCol>
    );
  }

  renderLogo() {
    const { SYSTEM_PROTECTION_LOGO, PREFERRED_PROTECTION_LOGO, PLATINUM_PROTECTION_LOGO } = ASSET_URLS;
    switch (this.props.activeWarranty) {
      case 'system-protection':
        return <SystemProtectionLogo src={SYSTEM_PROTECTION_LOGO} />;
        break;
      case 'preferred-protection':
        return <PreferredProtectionLogo src={PREFERRED_PROTECTION_LOGO} />;
        break;
      case 'platinum-protection':
        return <PlatinumProtectionLogo src={PLATINUM_PROTECTION_LOGO} />;
        break;
    }
  }

  openModal = () => {
    let modalTitle = '';
    let modalBody = '';
    switch (this.getWarranty().slug) {
      case 'standard':
        modalTitle = 'Standard Protection Limited Warranty';
        modalBody =
          'All Owens Corning® Shingle products come with a standard product warranty providing coverage against manufacturing defects. Each warranty starts with a TRU PROtection® Period during the initial years where coverage includes labor cost to repair/replace defective materials. After the TRU PROtection® Period is over, the coverage is for materials only and adjusted based on the age of your roof.';
        break;
      case 'system-protection':
        modalTitle = 'System Protection Limited Warranty';
        modalBody =
          'Provides full replacement coverage for manufacturing defects on your Owens Corning® shingles and all Owens Corning® roofing components for 50 years.';
        break;
      case 'preferred-protection':
        modalTitle = 'Preferred Protection Limited Warranty';
        modalBody =
          'Provides full replacement coverage for manufacturing defects on your Owens Corning® shingles and all Owens Corning® roofing components for 50 years. This warranty includes a 10-year limited warranty on contractor workmanship.';
        break;
      case 'platinum-protection':
        modalTitle = 'Platinum Protection Limited Warranty';
        modalBody =
          'Provides full replacement coverage for manufacturing defects on your Owens Corning® shingles and all Owens Corning® roofing components for 50 years. This warranty includes a limited lifetime warranty on contractor workmanship.';
        break;
    }
    this.setState({
      showModal: true,
      modalTitle,
      modalBody,
    });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { pink, gray, lightPink, hoverPink, hoverGray, lightGray } = this.state.colors;
    return (
      <FlexWrapper>
        <Modal show={this.state.showModal}>
          <ModalContent>
            <ModalHeader>
              <div>{this.state.modalTitle}</div>
              <div>
                <ModalCloseButton onClick={this.closeModal}>
                  <span
                    style={{
                      position: 'relative',
                      top: '-11px',
                      right: '-7px',
                      fontFamily: 'OCRoboto',
                      fontSize: '18px',
                      fontWeight: '100',
                    }}
                  >
                    x
                  </span>
                </ModalCloseButton>
              </div>
            </ModalHeader>
            <ModalBody>{this.state.modalBody}</ModalBody>
          </ModalContent>
        </Modal>

        <WarrantyType bgColor={this.isExtended() ? pink : gray} bgHover={this.isExtended() ? hoverPink : hoverGray}>
          {this.isExtended() ? 'Extended Coverage' : 'Standard Coverage'}
        </WarrantyType>

        <SpecificWarranty
          bgColor={this.isExtended() ? lightPink : lightGray}
          bgHover={this.isExtended() ? hoverPink : hoverGray}
          onClick={this.openModal}
        >
          {this.getWarranty().slug === 'standard' ? (
            <StandardWarrantyTitle>Standard Product Limited Warranty</StandardWarrantyTitle>
          ) : (
            this.renderLogo()
          )}
        </SpecificWarranty>

        <WarrantyDetailsTable>
          {this.renderLeftColumn()}
          {this.renderRightColumn()}
        </WarrantyDetailsTable>
      </FlexWrapper>
    );
  }
}

class MultipleWarrantyLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      modalTitle: '',
      modalBody: '',
    };
  }

  infoPopover(id, titleText, bodyText) {
    const { InfoCircle } = ASSET_URLS;
    return (
      <OverlayTrigger
        trigger="click"
        placement="right"
        rootClose
        overlay={
          <Popover id={id} style={{ opacity: 1 }} placement="right">
            <Popover.Title>{titleText}</Popover.Title>
            <Popover.Content>{bodyText}</Popover.Content>
          </Popover>
        }
      >
        <img
          src={InfoCircle}
          style={{
            display: 'inline',
            marginLeft: '7px',
          }}
          {...dataTrackMap({
            track: 'tooltip',
            destination: `${titleText} Tooltip`,
          })}
        />
      </OverlayTrigger>
    );
  }

  openModal = e => {
    let modalTitle = '';
    let modalBody = '';
    switch (e.target.dataset.warranty) {
      case 'standard':
        modalTitle = 'Standard Protection Limited Warranty';
        modalBody =
          'All Owens Corning® Shingle products come with a standard product warranty providing coverage against manufacturing defects. Each warranty starts with a TRU PROtection® Period during the initial years where coverage includes labor cost to repair/replace defective materials. After the TRU PROtection® Period is over, the coverage is for materials only and adjusted based on the age of your roof.';
        break;
      case 'system-protection':
        modalTitle = 'System Protection Limited Warranty';
        modalBody =
          'Provides full replacement coverage for manufacturing defects on your Owens Corning® shingles and all Owens Corning® roofing system components for 50 years.';
        break;
      case 'preferred-protection':
        modalTitle = 'Preferred Protection Limited Warranty';
        modalBody =
          'Provides full replacement coverage for manufacturing defects on your Owens Corning® shingles and all Owens Corning® roofing system components for 50 years. This warranty includes a 10-year limited warranty on contractor workmanship.';
        break;
      case 'platinum-protection':
        modalTitle = 'Platinum Protection Limited Warranty';
        modalBody =
          'Provides full replacement coverage for manufacturing defects on your Owens Corning® shingles and all Owens Corning® roofing system components for 50 years. This warranty includes a limited lifetime warranty on contractor workmanship.';
        break;
    }
    this.setState({
      showModal: true,
      modalTitle,
      modalBody,
    });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  renderLogo(v) {
    const { SYSTEM_PROTECTION_LOGO, PREFERRED_PROTECTION_LOGO, PLATINUM_PROTECTION_LOGO } = ASSET_URLS;
    switch (v) {
      case 'standard':
        return (
          <StandardLogoText onClick={this.openModal} data-warranty="standard">
            Standard Product
            <br />
            Limited Warranty
          </StandardLogoText>
        );
      case 'system-protection':
        return (
          <SystemProtectionLogo
            src={SYSTEM_PROTECTION_LOGO}
            onClick={this.openModal}
            data-warranty="system-protection"
          />
        );
      case 'preferred-protection':
        return (
          <PreferredProtectionLogo
            src={PREFERRED_PROTECTION_LOGO}
            onClick={this.openModal}
            data-warranty="preferred-protection"
          />
        );
      case 'platinum-protection':
        return (
          <PlatinumProtectionLogo
            src={PLATINUM_PROTECTION_LOGO}
            onClick={this.openModal}
            data-warranty="platinum-protection"
          />
        );
    }
  }

  renderWarrantyLogos() {
    const { standardCoverage, extendedCoverage } = this.props.warranties;
    const { InfoCircle, SYSTEM_PROTECTION_LOGO, PREFERRED_PROTECTION_LOGO, PLATINUM_PROTECTION_LOGO } = ASSET_URLS;
    const N = standardCoverage.length + extendedCoverage.length;
    return (
      <WarrantyTableHeader>
        <EmptyGridCorner style={{ flexBasis: '25.5%', borderLeft: '1px solid rgb(212, 212, 212)' }} />
        <FlexRow style={{ flexBasis: '74.5%' }}>
          {standardCoverage.length === 0 ? null : (
            <CoverageWarrantyWrapper
              style={{
                flexBasis: `${(standardCoverage.length / N) * 100}%`,
              }}
            >
              <CoverageWrapper bgColor="#dadada">
                <CoverageHeader>STANDARD COVERAGE</CoverageHeader>
              </CoverageWrapper>
              <WarrantiesWrapper bgColor="#e8e8e8">
                {standardCoverage.map((warranty, index) => (
                  <div
                    onClick={this.openModal}
                    key={index}
                    data-warranty={warranty}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexBasis: `${100 / standardCoverage.length}%`,
                    }}
                  >
                    {this.renderLogo(warranty)}
                  </div>
                ))}
              </WarrantiesWrapper>
            </CoverageWarrantyWrapper>
          )}
          {extendedCoverage.length === 0 ? null : (
            <CoverageWarrantyWrapper style={{ flexBasis: `${(extendedCoverage.length / N) * 100}%` }}>
              <CoverageWrapper bgColor="#fde4f0">
                <CoverageHeader>EXTENDED COVERAGE</CoverageHeader>
              </CoverageWrapper>
              <WarrantiesWrapper bgColor="#fef1f7">
                {extendedCoverage.map((warranty, index) => (
                  <div
                    key={index}
                    onClick={this.openModal}
                    data-warranty={warranty}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexBasis: `${100 / extendedCoverage.length}%`,
                    }}
                  >
                    {this.renderLogo(warranty)}
                  </div>
                ))}
              </WarrantiesWrapper>
            </CoverageWarrantyWrapper>
          )}
        </FlexRow>
      </WarrantyTableHeader>
    );
  }

  renderTableCell(flexGrowValue, bgColor) {
    return <FlexCol style={{ flexGrow: flexGrowValue, backgroundColor: bgColor }} />;
  }

  getProductDefectAttrib(category, index, key) {
    const { standardCoverage, extendedCoverage } = this.props.warranties;
    const n = standardCoverage.length + extendedCoverage.length;
    const standardCols = [];
    const extendedCols = [];
    standardCoverage.forEach((selectedWarrantySlug, selectedWarrantyIndex) => {
      WARRANTIES.forEach((warranty, warrantyIndex) => {
        if (warranty.slug === selectedWarrantySlug) {
          standardCols.push(
            <FlexCol
              style={{
                flexGrow: 1,
                justifyContent: 'center',
                alignItems: 'center',
                flexBasis: '50%',
                fontFamily: 'OCRoboto',
                color: '#333',
                backgroundColor: '#e8e8e8',
                height: key === 'Component Products' || key === 'Contractor Certification Required' ? '115px' : '100%',
                borderBottom: '1px solid rgb(212, 212, 212)',
              }}
            >
              <div
                style={{ textAlign: 'center' }}
                dangerouslySetInnerHTML={{
                  __html: warranty[category][index][key],
                }}
              />
            </FlexCol>
          );
        }
      });
    });
    extendedCoverage.forEach((selectedWarrantySlug, selectedWarrantyIndex) => {
      WARRANTIES.forEach((warranty, warrantyIndex) => {
        if (warranty.slug === selectedWarrantySlug) {
          extendedCols.push(
            <FlexCol
              style={{
                flexGrow: 1,
                justifyContent: 'center',
                alignItems: 'center',
                flexBasis: '50%',
                backgroundColor: '#fef1f7',
                height: key === 'Component Products' || key === 'Contractor Certification Required' ? '115px' : '100%',
                borderBottom: '1px solid rgb(212, 212, 212)',
                fontFamily: 'OCRoboto',
                color: '#333',
              }}
            >
              <div
                style={{ textAlign: 'center' }}
                dangerouslySetInnerHTML={{
                  __html: warranty[category][index][key],
                }}
              />
            </FlexCol>
          );
        }
      });
    });
    return (
      <FlexRow style={{ flexBasis: '74.5%' }}>
        <FlexRow style={{ flexBasis: `${(standardCoverage.length / n) * 100}%` }}>{standardCols}</FlexRow>
        <FlexRow style={{ flexBasis: `${(extendedCoverage.length / n) * 100}%` }}>{extendedCols}</FlexRow>
      </FlexRow>
    );
  }

  render() {
    const { InfoCircle } = ASSET_URLS;
    const { standardCoverage, extendedCoverage } = this.props.warranties;

    return (
      <div>
        <Modal show={this.state.showModal}>
          <ModalContent>
            <ModalHeader>
              <div>{this.state.modalTitle}</div>
              <div>
                <ModalCloseButton onClick={this.closeModal}>
                  <span
                    style={{
                      position: 'relative',
                      top: '-11px',
                      right: '-7px',
                      fontFamily: 'OCRoboto',
                      fontSize: '18px',
                      fontWeight: '100',
                    }}
                  >
                    x
                  </span>
                </ModalCloseButton>
              </div>
            </ModalHeader>
            <ModalBody>{this.state.modalBody}</ModalBody>
          </ModalContent>
        </Modal>
        {this.renderWarrantyLogos()}
        <CategoryHeader>Product Defects Coverage</CategoryHeader>
        <div>
          <FlexRow>
            <FlexCol
              style={{
                flexBasis: '25.5%',
                justifyContent: 'center',
                alignItems: 'center',
                borderLeft: '0.5px solid rgb(212, 212, 212)',
                borderBottom: '1px solid rgb(212, 212, 212)',
              }}
            >
              <WarrantyDetailName style={{ width: '100%' }}>
                <div
                  style={{ textAlign: 'right', display: 'inline', width: '100%' }}
                  dangerouslySetInnerHTML={{
                    __html: 'Overall Warranty Length',
                  }}
                />
                {this.infoPopover(
                  1,
                  'Overall Warranty Length',
                  'As a single family homeowner, lifetime coverage means that your warranty is in effect as long as you own your home.'
                )}
              </WarrantyDetailName>
            </FlexCol>
            {this.getProductDefectAttrib('Product Defects Coverage', 0, 'Overall Warranty Length')}
          </FlexRow>
          <FlexRow>
            <FlexCol
              style={{
                flexBasis: '25.5%',
                justifyContent: 'center',
                alignItems: 'center',
                borderLeft: '0.5px solid rgb(212, 212, 212)',
                borderBottom: '2px solid rgb(212, 212, 212)',
              }}
            >
              <WarrantyDetailName style={{ width: '100%' }}>
                <div
                  style={{ textAlign: 'right', display: 'inline', width: '100%' }}
                  dangerouslySetInnerHTML={{
                    __html: 'Products Included',
                  }}
                />
              </WarrantyDetailName>
            </FlexCol>
            {this.getProductDefectAttrib('Product Defects Coverage', 1, 'Products Included')}
          </FlexRow>
          <FlexRow>
            <FlexCol
              style={{
                flexBasis: '25.5%',
                borderLeft: '0.5px solid rgb(212, 212, 212)',
                borderBottom: '1px solid rgb(212, 212, 212)',
              }}
            >
              <WarrantyDetailName style={{ width: '100%' }}>
                <div
                  style={{ textAlign: 'right', display: 'inline', width: '100%' }}
                  dangerouslySetInnerHTML={{
                    __html: 'TRU PROtection<sup>&reg;</sup> Period',
                  }}
                />
                {this.infoPopover(
                  2,
                  'TRU PROtection Period',
                  'Each warranty starts with a TRU PROtection® Period during the initial years where coverage includes labor cost to repair/replace defective materials.'
                )}
              </WarrantyDetailName>
            </FlexCol>

            {this.getProductDefectAttrib('Product Defects Coverage', 2, 'TRU PROtection<sup>&reg;</sup> Period')}
          </FlexRow>
          <FlexRow>
            <FlexCol
              style={{
                flexBasis: '25.5%',
                borderLeft: '0.5px solid rgb(212, 212, 212)',
                borderBottom: '1px solid rgb(212, 212, 212)',
              }}
            >
              <WarrantyDetailName style={{ width: '100%' }}>
                <div
                  style={{ textAlign: 'right', display: 'inline', width: '100%' }}
                  dangerouslySetInnerHTML={{
                    __html: 'Materials Only Coverage',
                  }}
                />
                {this.infoPopover(
                  3,
                  'Materials Only Coverage',
                  'After the TRU PROtection® Period is over, warranty compensation is for materials only. The compensation is reduced based on the number of years you’ve enjoyed your roof from installation date through the date of your claim.'
                )}
              </WarrantyDetailName>
            </FlexCol>
            {this.getProductDefectAttrib('Product Defects Coverage', 3, 'Materials Only Coverage')}
          </FlexRow>
          <FlexRow>
            <FlexCol
              style={{
                flexBasis: '25.5%',
                borderLeft: '0.5px solid rgb(212, 212, 212)',
                borderBottom: '2px solid rgb(212, 212, 212)',
              }}
            >
              <WarrantyDetailName style={{ width: '100%' }}>
                <div
                  style={{ textAlign: 'right', display: 'inline', width: '100%' }}
                  dangerouslySetInnerHTML={{
                    __html: 'Blow Off Coverage<sup>*</sup>',
                  }}
                />
                {this.infoPopover(
                  4,
                  '110 MPH Wind Blow Off Coverage / 130 MPH Coverage for Duration',
                  'After your shingles have achieved thermal sealing they will be covered if they experience blow-offs or wind damage in winds (including gusts) for the wind speed listed for the period from the original installation date.'
                )}
              </WarrantyDetailName>
            </FlexCol>
            {this.getProductDefectAttrib('Product Defects Coverage', 4, 'Blow Off Coverage<sup>*</sup>')}
          </FlexRow>
          <FlexRow>
            <FlexCol
              style={{
                flexBasis: '25.5%',
                borderLeft: '0.5px solid rgb(212, 212, 212)',
                borderBottom: '1px solid rgb(212, 212, 212)',
              }}
            >
              <WarrantyDetailName style={{ width: '100%' }}>
                <div
                  style={{ textAlign: 'right', display: 'inline', width: '100%' }}
                  dangerouslySetInnerHTML={{
                    __html: 'StreakGuard<sup>&trade;</sup> Algae Resistance**',
                  }}
                />
                {this.infoPopover(
                  5,
                  'StreakGuard® Algae Resistance**',
                  'Warranty length following the date of installation against brown-black staining caused by growth of cyanobacteria Gloeocapsa magma algae.'
                )}
              </WarrantyDetailName>
            </FlexCol>
            {this.getProductDefectAttrib(
              'Product Defects Coverage',
              5,
              'StreakGuard<sup>&trade;</sup> Algae Resistance**'
            )}
          </FlexRow>

          <CategoryHeader>Workmanship Coverage</CategoryHeader>
          <FlexRow>
            <FlexCol
              style={{
                flexBasis: '25.5%',
                justifyContent: 'center',
                borderLeft: '0.5px solid rgb(212, 212, 212)',
                borderBottom: '1px solid rgb(212, 212, 212)',
              }}
            >
              <WarrantyDetailName style={{ width: '100%' }}>
                <div
                  style={{ textAlign: 'right', display: 'inline', width: '100%' }}
                  dangerouslySetInnerHTML={{
                    __html: 'Coverage Period',
                  }}
                />
                {this.infoPopover(
                  6,
                  'Coverage Period',
                  'Contractor workmanship coverage includes any defective installation of the Owens Corning® Roofing System. Contractor workmanship is available only through certified Owens Corning® Roofing Platinum or Preferred Contractors.'
                )}
              </WarrantyDetailName>
            </FlexCol>
            {this.getProductDefectAttrib('Workmanship Coverage', 0, 'Coverage Period')}
          </FlexRow>
          <CategoryHeader>Key Requirements</CategoryHeader>
          <FlexRow>
            <FlexCol
              style={{
                flexBasis: '25.5%',
                justifyContent: 'center',
                borderLeft: '0.5px solid rgb(212, 212, 212)',
                borderBottom: '1px solid rgb(212, 212, 212)',
              }}
            >
              <WarrantyDetailName style={{ width: '100%' }}>
                <div
                  style={{ textAlign: 'right', display: 'inline', width: '100%' }}
                  dangerouslySetInnerHTML={{
                    __html: 'Additional Cost',
                  }}
                />
              </WarrantyDetailName>
            </FlexCol>
            {this.getProductDefectAttrib('Key Requirements', 0, 'Additional Cost')}
          </FlexRow>
          <FlexRow>
            <FlexCol
              style={{
                flexBasis: '25.5%',
                justifyContent: 'center',
                borderBottom: '1px solid rgb(212, 212, 212)',
                borderLeft: '1px solid rgb(212, 212, 212)',
              }}
            >
              <WarrantyDetailName style={{ width: '100%' }}>
                <div
                  style={{ textAlign: 'right', display: 'inline', width: '100%' }}
                  dangerouslySetInnerHTML={{
                    __html: 'Component Products',
                  }}
                />
                {this.infoPopover(
                  7,
                  'Owens Corning Component Products',
                  'The minimum number of Owens Corning® component product categories that must be installed to qualify for warranty coverage. The categories of component products include underlayments, intake and exhaust ventilation, hip & ridge shingles, ice & water barriers, and starter shingles.'
                )}
              </WarrantyDetailName>
            </FlexCol>
            {this.getProductDefectAttrib('Key Requirements', 1, 'Component Products')}
          </FlexRow>
          <FlexRow>
            <FlexCol
              style={{
                flexBasis: '25.5%',
                justifyContent: 'center',
                borderBottom: '.5px solid rgb(212, 212, 212)',
                borderLeft: '1px solid rgb(212, 212, 212)',
              }}
            >
              <WarrantyDetailName style={{ width: '100%' }}>
                <div
                  style={{ textAlign: 'right', display: 'inline', width: '100%' }}
                  dangerouslySetInnerHTML={{
                    __html: 'Contractor Certification Required',
                  }}
                />
                {this.infoPopover(
                  8,
                  'Contractor Certification Required',
                  'Your Owens Corning® Roofing System must be installed by a certified Owens Corning® Roofing Platinum or Preferred Contractor and your contractor must register the warranty within 60 days of the installation.'
                )}
              </WarrantyDetailName>
            </FlexCol>
            {this.getProductDefectAttrib('Key Requirements', 2, 'Contractor Certification Required')}
          </FlexRow>
        </div>
      </div>
    );
  }

  renderHeader(text) {
    return <WarrantyDetailsHeader>{text}</WarrantyDetailsHeader>;
  }

  renderWarrantyDetailsTable() {
    return (
      <div>
        {this.renderHeader('Product Defects Coverage')}
        {this.renderProductDefectsCoverage()}
        {this.renderHeader('Workmanship Coverage')}
        {this.renderHeader('Key Requirements')}
      </div>
    );
  }
}

export default class DesktopWarranty extends Component {
  render() {
    return <div>{this.renderWarrantyLayout()}</div>;
  }

  renderWarrantyLayout = () => {
    const { standardCoverage, extendedCoverage } = this.props.activeWarranties;
    const n = standardCoverage.length + extendedCoverage.length;
    return <MultipleWarrantyLayout warranties={this.props.activeWarranties} />;
  };
}
